<template>
    <div class="travels-container">
        <h3 class="heading-3 mb-5">
            {{ $t('all_destinations_one_day') }}
        </h3>
        <div class="flex-wrap items-center gap-5 justify-center w-full box-destinies-container">
            <div v-for="(destiny, index) in destinies" :key="destiny.name" class="">
              <app-card-destiny
                  :tripId="index"
                  :image="destiny.image"
                  :alt_image="destiny.alt_image"
                  :title="destiny.title"
                  :price="destiny.price"
                  v-on:linkClicked="handleSelectTrip(destiny.cityCodeTo)"
                ></app-card-destiny>
            </div>
        </div>
        <div class="container mx-auto">
        <v-btn
            rounded
            elevation="0"
            color="secondary"
            height="50"
            class="avm-btn avm-btn--large mx-auto block mt-4"
            @click.stop="navigateToDestinies()"
        >
            {{ $t('all_destinations')}}
        </v-btn>
        </div>
    </div>
</template>
<script>

import { GET_LOCATIONS } from "../../store/destinies/getter-types";
import Axios from "axios";
import { mapActions, mapGetters } from "vuex";
import { FETCH_DESTINIES } from "../../store/destinies/action-types";
import { GET_DESTINIES } from "../../store/destinies/getter-types";

export default {
  props: {
    title: {
      type: String,
      required: false
    },
    subtitle: {
      type: String,
      required: false
    },
    btnLabel: {
      type: String,
      required: false
    }
  },
  computed: {
    ...mapGetters({
      getDestinies: GET_DESTINIES
    }),
    destinies(){
      return this.getDestinies.flights.slice(0, 8);
    }
  },
  methods: {
    ...mapActions({
      fetchDestinies: FETCH_DESTINIES
    }),
    navigateToDestinies() {
      this.$router.push({ name: "destinies" });
    }
  },
  created() {
    this.fetchDestinies({});
  }
};
</script>
<style lang="scss">
.travels-container {
    @media screen and (max-width: 1240px) {
		padding: 40px 20px;
	}
    padding: 60px 0;
}

.box-destinies-container {
    @media screen and (max-width: 500px) {
		display: grid;
        grid-template-columns: 1fr 1fr;
	}
    display: flex;
}
</style>
